import { useEffect } from "react";
import { UpdateFn } from "../../types";
import { DEBUG } from "../../api";

const useFetch = <T,>(setter: UpdateFn<T>, getter: () => Promise<T>): void => {
  useEffect(() => {
    if (DEBUG) return;
    getter()
      .then((res) => setter(res))
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useFetch;
